<template>
  <div>
    <div class="profit-panel" v-if="can_see">
      <div class="profit-header">
          <span style="font-size: 20px;color: #00CC88;margin-left: 100px">数据日期: {{date}}</span>
          <div class="profit-button" @click="downloadProfit" v-if="can_see">区域毛利(率)月报下载</div>
          <!-- <div class="profit-button-day" @click="downloadProfitDay">区域毛利(率)日报下载</div> -->
      </div>
      <div class="profit-total-content">
        <div class="profit-total">
          <div class="label-value"><span class="ziti">分公司合计<span style="font-size:10px">(含基础油):</span></span></div>
          <div class="label-value"><span class="ziti">销售量</span><br><span class="ziti2" style="color:#00CC88;">{{ areaTotals.sales_volume }}</span><span style="font-size:12px;color:#00CC88;">吨</span></div>
          <div class="label-value"><span class="ziti">营收</span><br><span class="ziti2" style="color:#409EFF;">{{ areaTotals.sales_revenue }}</span><span style="font-size:12px;color:#409EFF;">万</span></div>
          <!-- <div class="label-value" style="margin-left:120px;text-align:center;"><span class="ziti">毛利润</span><br><span class="ziti2" style="color:#FF605F;">{{ areaTotals.gross_profit }}</span></div> -->
          <div class="label-value"><span class="ziti">利润</span><br><span class="ziti2" style="color:red;">{{ areaTotals.net_profit }}</span><span style="font-size:12px;color:red;">万</span></div>
          <!-- <div class="label-value" style="margin-left:120px;text-align:center;"><span class="ziti">利润率</span><br><span class="ziti2" style="color:#FFAD32;">{{ areaTotals.gross_rate }}</span></div> -->

        </div>

      </div>
      <div class="main-board">
        <div class="charts-title">
          <span style="margin-left: 700px">
            <span class="daily-square color-green"></span>销售量
            <span class="daily-square color-blue" style="margin-left: 20px"></span>营收
            <span class="daily-square color-red" style="margin-left: 20px"></span>利润
          </span>
        </div>
        <div id="maindash"></div>
      </div>
    </div>
    <div class="no-profit-panel" v-else>
      <div class="no-profit-panel-pic">
          <img src="http://static.sprucesmart.com/86e6c18e7eff11ea8a7100163e03d698.png%22" alt="">您没有全限查看
      </div>
      
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {

  },
  data() {
    return {
        areaTotals: {},
        can_see:Boolean,
        date:'',
        profitData:[],
        option : {
            title: {
                text:'区域毛利情况表',
                // textAlign:'center',
                left: '5%'

            },
            color: ['#FF9900'],
            tooltip : {
                trigger: 'axis',
                // color: ['#db0c08'],
                // axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                //     type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                // }
            },
            grid: {
                left: '1%',
                right: 0,
                bottom: '3%',
                containLabel: true
            },
            xAxis : [
                {
                    type : 'category',
                    data : [],
                    axisTick: {
                        alignWithLabel: true
                    },
                    textStyle:{
                        lineHeight:400
                    },
                    axisLabel:{ //调整x轴的lable
                        textStyle:{
                            fontSize:10 // 让字体变化
                        }},
                    // axisLabel: {
                    //     interval:0,
                    //     rotate:70
                    // },
                    // axisLabel: {
                    //     interval: 0,
                    //     formatter:function(value)
                    //     {
                    //         return value.split("").join("\n");
                    //     }
                    // }
                }
            ],
            yAxis: [{
                        type: 'value',
                        splitLine: {
                            show: false
                        },
                        name: '销售量/吨 营收/万元',
                        min: -0,
                    },
                    {
                        type: 'value',
                        scale: true,
                        name: '利润/万元 利润率/%',
                        min: -0,
                    }
                // {
                //     type: 'value',
                //     scale: true,
                //     name: '利润率 %',
                //     min: -10,
                // }
            ],
            series : [
                {
                    name: '销售量',
                    type: 'bar',
                    yAxisIndex: 0,
                    barGap: 0,
                    barWidth: 20,
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#00CC88'
                        }
                    },
                    data: [],
                },
                {
                    name: '营收',
                    type: 'bar',
                    yAxisIndex: 0,
                    barGap: 0,
                    barWidth: 20,
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#409EFF'
                        }
                    },
                    data: [],
                },
                {
                    name: '利润',
                    type: 'bar',
                    yAxisIndex: 1,
                    barGap: 0,
                    barWidth: 20,
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#FF0400'
                        }
                    },
                    data: [],
                },
                {
                    name:'利润率',
                    yAxisIndex: 1,
                    itemStyle: {
                        normal: {
                        color: '#ff0000'
                        }
                    },
                    lineStyle: {
                        color: '#ff0000'
                    },
                    type:'line',
                    smooth:true,
                    data: []
                },
                // color: ['#00EE00', '#FF9F7F','#FFD700']
            ]
        },

        

    };
  },
  created(){
    this.isLoading = true;
    this.init();
},
  methods: {
    downloadProfit(){
        window.location.href = 'https://xarh.sprucesmart.com/api/v5/download_profit/';
    },
    downloadProfitDay(){
        window.location.href = 'https://bjrh.datoushow.com/api/v2/download_day_profit';
    },
    init(){
       axios.get('https://xarh.sprucesmart.com/api/v5/profit/').then((res)=>{
            console.log(res)
            this.can_see = res.data.can_see
            this.areaTotals = res.data.total
            this.date=res.data.data.total_data.date
            this.$nextTick(() => {
            this.draw('maindash', res.data.data.total_data.table_data, res.data.data.total_data.sign)
                // let l=[1,2,3,4,5]
                // for (let i in l){
                //     this.draw("chart"+l[i], res.data.data.pl_data[i].table_data, res.data.data.pl_data[i].sign)
                // }
            });
        })
    },
    draw (dashId, data, title) {
        let sales_volume_value = []; // 销售量
        let sales_revenue_values = []; // 营收
        let gross_rate_values = []; // 利润
        let gross_rate = [];
        let xs = [];
        for (let i in data) {
            // console.log('data[i]', data[i])
            sales_volume_value.push(parseFloat(data[i].sales_volume))
            sales_revenue_values.push(parseFloat(data[i].sales_revenue))
            gross_rate_values.push(parseFloat(data[i].gross_profit))
            gross_rate.push(parseInt(data[i].gross_rate * 100))
            // gross_rate_values.push((parseFloat(data[i].gross_profit)*100).toFixed(0))
            xs.push(data[i].name)
        }
        let dash = this.$echarts.init(document.getElementById(dashId));
        let tempOption = JSON.parse(JSON.stringify(this.option))
        // tempOption.title.text = title
        tempOption.series[0].data = sales_volume_value
        tempOption.series[1].data = sales_revenue_values
        tempOption.series[2].data = gross_rate_values
        tempOption.series[3].data = gross_rate
        tempOption.xAxis[0].data = xs
        dash.setOption(tempOption)
    },
  }
};
</script>

<style scoped>
  .profit-panel{
    width: 100%;
    padding: 0 20px;
  }
  .no-profit-panel {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .no-profit-panel-pic {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 209px;
    height: 186px;
    font-size:18px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(33,50,84,1);
    
    
  }
  .no-profit-panel-pic img {
    width: 100%;
    height: 100%;
    margin-bottom: 30px;
  }
  .profit-button {
    width:185px;
    height:38px;
    line-height: 38px;
    background-color: #00CC88;
    font-size:16px;
    font-family:PingFangSC;
    font-weight:400;
    color: #ffffff;
    text-align: center;
    position: absolute;
    right: 250px;
    top: 11px;
    cursor: default;
  }
  .profit-button-day {
    right: 50px;
    width:185px;
    height:38px;
    line-height: 38px;
    background-color:#FBAD33;
    font-size:16px;
    font-family:PingFangSC;
    font-weight:400;
    color: #ffffff;
    text-align: center;
    position: absolute;
    /* right: 250px; */
    top: 11px;
    cursor: default;
  }
  .profit-header{
    width: 100%;
    height: 60px;
    background-color: #ffffff;
    font-size:28px;
    font-family:PingFangSC;
    font-weight:500;
    color:rgba(48,48,48,1);
    line-height:60px;
    /*text-align: center;*/
    /*margin-left: 100px;*/
    position: relative;
    margin-bottom: 45px;
  }
  #maindash {
    width:100%;
    height: 90%;
    padding: 0 5px;
    /*margin-left: 100px;*/
  }
  .main-board {
    height: 415px;
    width: 100%;
    border: 1px solid #ccc;
    background-color: #ffffff;
  }
  .charts{
    width:100%;
    height: 90%;
    background-color: #ffffff;
    /*background-color: #ffffff;*/
    /*float: left;*/
    /*border: 1px solid #E1E1E1;*/
  }
  .charts-title{
    width: 100%;
    height: 39px;
    line-height: 39px;
    border-bottom: 1px solid #E1E1E1;
    font-size:18px;
    font-family:PingFangSC;
    font-weight:500;
    color: #303030;
    padding-left: 10px;
  }
  .daily-square {
    display: inline-block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 8px;
  }
  .color-blue{
    background-color: #409EFF;
  }
  .color-green{
    background-color: #00CC88;
  }
  .color-red {
      background-color: #FF0400;
  }
  .profit-total-content {
    width: 100%;
  }
  .profit-total{
    display: flex;
    justify-content: space-between;
    align-items:center;
    width:100%;
    height:110px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(197,197,197,1);
    margin-bottom: 30px;
    padding: 15px 30px;
    box-sizing: border-box;
  }
  .profit-total .label-value {
    /* float: left; */
    width: 195px;

  }
  .ziti{
    font-size:18px;
  }
  .ziti2{
    font-size:36px;
    font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/ProfitDataIndex.vue